"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BasicStorage_1 = require("./BasicStorage");
var debugLogger_1 = require("../loggers/debugLogger");
var loggers_1 = require("../loggers");
var PlatformStorage_1 = require("./PlatformStorage");
var GROUPS_CACHE_EXPIRATION = 5000;
var GroupsStorage = /** @class */ (function (_super) {
    tslib_1.__extends(GroupsStorage, _super);
    function GroupsStorage(storage) {
        return _super.call(this, storage) || this;
    }
    GroupsStorage.fromControllerConfig = function (controllerConfig) {
        var storage;
        try {
            storage = controllerConfig.platformAPIs.storage.session;
            loggers_1.ConsoleLogger.mode = debugLogger_1.getLogLevelFromControllerConfig(controllerConfig);
        }
        catch (e) {
            console.log('Failed to get storage from controller config platformAPIs');
            storage = new BasicStorage_1.BasicStorage();
        }
        return new GroupsStorage(storage);
    };
    GroupsStorage.prototype.getGroup = function (groupId) {
        try {
            var _group = this.storage.getItem(groupId);
            if (!_group) {
                loggers_1.ConsoleLogger.log(groupId + " is not in the storage");
                return null;
            }
            var group = JSON.parse(_group);
            var isValidGroup = group.groupId === groupId || group.slug === groupId;
            loggers_1.ConsoleLogger.log(groupId + " isValidGroup " + isValidGroup);
            return isValidGroup && group;
        }
        catch (e) {
            loggers_1.ConsoleLogger.log('Failed to get group from storage');
        }
        return null;
    };
    GroupsStorage.prototype.removeGroup = function (groupId) {
        var group = this.getGroup(groupId);
        if (group) {
            var id = group.groupId, slug = group.slug;
            this.storage.removeItem(id);
            this.storage.removeItem(slug);
        }
    };
    GroupsStorage.prototype.setGroup = function (group) {
        try {
            var groupId = group.groupId, slug = group.slug;
            var cachedGroup = JSON.stringify(group);
            this.storage.setItem(groupId, cachedGroup);
            this.storage.setItem(slug, cachedGroup);
        }
        catch (e) {
            console.log('Failed to write a group to storage');
        }
    };
    return GroupsStorage;
}(PlatformStorage_1.PlatformStorage));
exports.GroupsStorage = GroupsStorage;
//# sourceMappingURL=GroupsStorage.js.map